import React from 'react';
import Person from './Person';
import { People, List } from './styles';
import Title from '../../Symbols/Title';
import WithMore from '../WithMore';

export function PeopleComponent({
	title,
	items = [],
	renderInfo
}) {
	return <People>
		<Title>{title}</Title>

		<List>
			{items.map(item => <Person key={item.id} {...item} renderInfo={renderInfo} />)}
		</List>
	</People>;
}

export default WithMore(PeopleComponent, { length: 12 });
